var link_viewer_wrapper_default = {
  "anchor": "xUdNb",
  "link": "lS3uZ"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
